import {LOOK_ROOM_TYPES} from "../bvcomponents/look/core/constants";

/**
 * @param preset {object} visualizer management preset
 * @param forVisualizerType {string} visualizer type
 * @return {object} visualizer management preset
 */
export const updatePresetRoomLayout = (preset, forVisualizerType = document.kvConfig.visualizerType) => {
  if (!preset.lookId) {
    preset.lookId = 0;
  }
  if ((forVisualizerType === "bvLook")) {
    if (preset.roomType === LOOK_ROOM_TYPES.as) {
      preset.layout_type = preset.layout_type > 20
        ? preset.layout_type - 10
        : preset.layout_type < 10
          ? preset.layout_type + 10
          : preset.layout_type;
    } else {
      preset.layout_type = preset.layout_type >= 10
        ? preset.layout_type - 10
        : preset.layout_type;
    }
  }
  return preset
}

export const updatePresetsArray = (responseDefaults, forVisualizerType) => {
  let bvPresets = JSON.parse(responseDefaults) || [];
  const noPresetsAtAll = bvPresets.every(preset => !preset.id);
  return bvPresets.map((preset, presetIndex) => {
    if (noPresetsAtAll) {
      preset.id = presetIndex + 1;
    } else if (!Number.isInteger(preset.id)) {
      preset.id = presetIndex + 100 // 100 is to make id's really unique
    }
    preset = updatePresetRoomLayout(preset, forVisualizerType);
    return preset
  });
}
